// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28855":"fabefbfb","35187":"fab2e17e","38487":"fab3fefb","47984":"fabefbfb","57287":"fabefbfb","60107":"fab1defb","68833":"fabefbfb","70889":"fab3fefb","75361":"fabefbfb","75439":"fab77efb","81426":"fab0409e","95113":"fabefbfb","95561":"fabefbfb"}[chunkId] + ".chunk.css";
};